import * as React from "react";
import { Stats, calculateBinsHints, calculateCustomBins } from '../model/index.js';
import { BinHintsPopup } from './BinHintsPopup.js';
export function BinDefinitionCustom({ data, setBins, decimals }) {
    const stats = React.useMemo(() => new Stats(data.map(x => x.value)), [data]);
    const binsHints = React.useMemo(() => calculateBinsHints(stats), [stats]);
    const [binParams, setBinParams] = React.useState([]);
    const textArea = React.useRef(null);
    function parseBinBoundaries() {
        var _a;
        let text = '';
        try {
            text = ((_a = textArea.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        }
        catch (error) {
            text = '';
        }
        const tokens = text.split(';');
        const values = tokens.map(t => Number(t.trim().replace(',', '.')));
        for (const v of values) {
            if (isNaN(v)) {
                return [];
            }
        }
        console.log("values:");
        console.log(values);
        return values;
    }
    function refreshBins() {
        const bins = calculateCustomBins({
            orderedSample: stats.orderedSample,
            boundaries: binParams
        });
        return bins;
    }
    React.useEffect(() => {
        setBins(refreshBins());
    }, [stats, binParams]);
    function onSubmit(e) {
        e.preventDefault();
        setBinParams(parseBinBoundaries());
    }
    return (React.createElement("div", null,
        React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 10 } },
            React.createElement("p", null, "Hranice t\u0159\u00EDd od\u011Blen\u00E9 st\u0159edn\u00EDkem, mezery libovoln\u00E9."),
            React.createElement(BinHintsPopup, { binsHints: binsHints, decimals: decimals })),
        React.createElement("textarea", { placeholder: 'Zadejte d\u011Blic\u00ED body (hranice t\u0159\u00EDd) odd\u011Blen\u00E9 st\u0159edn\u00EDkem...', ref: textArea, style: { height: 80, width: "90%" } }),
        React.createElement("button", { onClick: onSubmit }, "P\u0159epo\u010D\u00EDtat")));
}
//# sourceMappingURL=BinDefinitionCustom.js.map